<div class="card shadow border-0 mb-3 tab-pane fade fade-in-zoom active show" role="tabpanel">
  <div class="card-header fw-bold bg-tertiary p-3 border-0 d-flex justify-content-between align-items-center">
    <h2 class="fs-6 fw-bold mb-0">
      <i class="bi bi-database-gear me-2 text-primary"></i>Custom Payouts
    </h2>
    <a [routerLink]="['add']" *isGranted="['ROLE_API_CUSTOM_PAYOUT_WRITE']" class="btn btn-primary fw-bold"
      type="button">
      <i class="bi bi-plus-lg me-2"></i>Add Custom Payout
    </a>
  </div>

  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover align-middle">
        <thead>
          <tr>
            <th></th>
            <th>Name</th>
            <th>Goal</th>
            <th>Goal type</th>
            <th>Sub IDs</th>
            <th>Offers</th>
            <th>Payout amount</th>
            <th>Payout percent</th>
            <th>Effective Date</th>
            <th>User</th>
            <th class="text-center">Enabled</th>
            <th class="text-end">Actions</th>
          </tr>
        </thead>
        @if (!loader.isLoading()) {
          <tbody>
            @for (customPayout of customPayouts; track customPayout; let i = $index) {
              <tr>
                <td>
                  <button (click)="moveRule(i, 'up')" [disabled]="i === 0" class="btn btn-sm btn-outline-primary me-2"
                    type="button">
                    <i class="bi bi-arrow-up"></i>
                  </button>
                  <button (click)="moveRule(i, 'down')" [disabled]="i === customPayouts.length - 1"
                    class="btn btn-sm btn-outline-primary" type="button">
                    <i class="bi bi-arrow-down"></i>
                  </button>
                </td>
                <td>{{ customPayout.name }}</td>
                <td>{{ customPayout.goal }}</td>
                <td>{{ customPayout.goalType }}</td>
                <td>
                  @for (subId of customPayout.subIds; track subId) {
                    <span class="badge bg-success me-2">{{ subId.subId }}</span>
                  }
                </td>
                <td class="offers-cell">
                  <div class="d-flex flex-wrap gap-1">
                    @for (offer of customPayout.offers; track offer) {
                      <span class="badge bg-info">{{ offer.offer.name }}</span>
                    }
                  </div>
                </td>
                <td>@if (customPayout.payoutAmount!=null) {
                  <span
                  >{{ customPayout.payoutAmount | currency: 2: $safeNavigationMigration(customPayout.currency?.isoCode) }}</span>
                }
              </td>
              <td>@if (customPayout.payoutPercent!=null) {
                <span>{{ customPayout.payoutPercent }}%</span>
              }</td>
              <td>{{ customPayout.startingAt | date: 'dd/MM/yyyy' }}</td>
              <td>{{ customPayout.user }}</td>
              <td class="text-center">
                @if (customPayout.enabled) {
                  <i class="bi bi-check-circle-fill text-success"></i>
                }
                @if (!customPayout.enabled) {
                  <i class="bi bi-x-circle-fill text-warning"></i>
                }
              </td>
              <td class="text-end">
                <button *isGranted="['ROLE_API_USER_EVENT_READ']" (click)="openUserEventModal(customPayout)" class="btn btn-outline-primary btn-sm me-2">
                  <i class="bi bi-eye me-2"></i>View log
                </button>
                <a [routerLink]="[customPayout.id]" class="btn btn-outline-primary btn-sm me-2">
                  <i class="bi bi-pencil me-2"></i>Edit
                </a>
                <button (click)="delete(customPayout)" appConfirm class="btn btn-outline-danger btn-sm">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      }
    </table>
  </div>
</div>
</div>
